module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('navbar', [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav d-md-down-none"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-toggler sidebar-toggler",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.sidebarMinimize
    }
  }, [_vm._v("☰")])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav ml-auto header"
  }, [_c('dropdown', {
    staticClass: "nav-item nav-profile",
    attrs: {
      "size": "nav"
    }
  }, [_c('span', {
    slot: "button"
  }, [_c('i', {
    staticClass: "fa fa-user fa-lg"
  }), _vm._v(" "), _c('span', {
    staticClass: "d-md-down-none"
  }, [_vm._v(_vm._s(_vm.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right",
    slot: "dropdown-menu"
  }, [(_vm.$guser.isClinicMulti()) ? _c('div', {
    staticClass: "dropdown-header text-center"
  }, [_c('strong', [_vm._v("Clinics")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.$guser.user.clinics), function(clinic, index) {
    return (_vm.$guser.isClinicMulti()) ? _c('a', {
      key: index,
      staticClass: "dropdown-item",
      attrs: {
        "href": '/clinic/general?ref_clinic_id=' + clinic.id
      }
    }, [_c('i', {
      staticClass: "fa fa-hospital-o"
    }), _vm._v(" " + _vm._s(clinic.clinic_name) + "\n        ")]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-header text-center"
  }, [_c('strong', [_vm._v("Others")])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), (_vm.$guser.isClinicMulti()) ? _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": '/clinic_multi'
    }
  }, [_c('i', {
    staticClass: "fa fa-hospital-o"
  }), _vm._v(" หน้าแรก\n        ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": '/package/me'
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.my_subcription')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.signout
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" " + _vm._s(_vm.$t('message.menu.sign_out')))])], 2)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-326b9976"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/containerComponents/Header.vue
// module id = 995
// module chunks = 1